const translations = {
    delete: 'Delete',
    email: 'Email',
    expires: 'Expires',
    resend: 'Resend',
    role: 'Role',
    sent: 'Sent',
    status: 'Status'
};

export default translations;
